import { makeStyles } from 'tss-react/mui';

const useTooltipStyles = makeStyles()((theme) => ({
  tooltipContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    minWidth: 0,
  },
  tooltipContainerFullWidth: {
    display: 'flex',
    width: '100%',
  },
  tooltipVisible: {
    opacity: '1 !important',
  },
  tooltipInteractive: {
    pointerEvents: 'auto',
  },
  tooltip: {
    position: 'fixed',
    padding: theme.spacing(0.75, 1.25),
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    borderRadius: '10px',
    whiteSpace: 'pre-line',
    zIndex: theme.zIndex.tooltip,
    pointerEvents: 'none',
    opacity: 0,
    transition: 'opacity 200ms ease',
    maxWidth: '80vw',
    border: `1px solid ${theme.palette.custom.border.secondary}`,
    boxShadow: theme.shadows[4],
  },
  adornedContent: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
}));

export default useTooltipStyles;
